import { css } from "@emotion/react"
import { containerWidth, baseFontSize } from "@mkt/cp/src/styles/Variables"
import { above } from "@mkt/cp/src/styles/Breakpoints"

import OutlineMoney from "iq-blueberry/dist/reactIcons/OutlineMoney"
import OutlineAnnuity from "iq-blueberry/dist/reactIcons/OutlineAnnuity"
import OutlineContactless from "iq-blueberry/dist/reactIcons/OutlineContactless"
import OutlineCreditCardPoints from "iq-blueberry/dist/reactIcons/OutlineCreditCardPoints"
import OutlineDiscounts from "iq-blueberry/dist/reactIcons/OutlineDiscounts"
import OutlineGift from "iq-blueberry/dist/reactIcons/OutlineGift"
import OutlineLegalInformation from "iq-blueberry/dist/reactIcons/OutlineLegalInformation"
import OutlinePartnership from "iq-blueberry/dist/reactIcons/OutlinePartnership"

export const container = css`
  margin: 0 auto;
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 24px;
  padding-right: 24px;

  ${above["sm"]} {
    max-width: ${containerWidth.sm};
  }

  ${above["m"]} {
    max-width: ${containerWidth.m};
  }

  ${above["l"]} {
    max-width: ${containerWidth.l};
  }

  ${above["xl"]} {
    max-width: ${containerWidth.xl};
  }
`

export const getDuration = (i, start = 0.09) => `${0.32 + i * start}s`

export const toRem = (value) => {
  if (!value) return
  const number = baseFontSize.replace("px", "")
  const cleanValue = String(value).replace("px", "")
  const rem = (1 / number) * cleanValue + "rem"

  return rem
}

export const arcuiro = css`
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(222, 61, 181, 1) 65%,
    rgba(64, 137, 237, 1) 100%
  );
`

export const mapIcons = {
  OutlineMoney: <OutlineMoney />,
  OutlineAnnuity: <OutlineAnnuity />,
  OutlineContactless: <OutlineContactless />,
  OutlineCreditCardPoints: <OutlineCreditCardPoints />,
  OutlineDiscounts: <OutlineDiscounts />,
  OutlineGift: <OutlineGift />,
  OutlineLegalInformation: <OutlineLegalInformation />,
  OutlinePartnership: <OutlinePartnership />,
}
